import { VelocityClientMetricsEvents } from '@velocity-exchange/sdk';

// Event handler types
export type EmitterHandler<T> = (data: T) => void;
export type DriftClientTxSignedHandler = EmitterHandler<
	VelocityClientMetricsEvents['txSigned']
>;

// TX metrics options
export type TxMetricsOpts = {
	measurePreSignTimeMetricKey?: string;
	measurePreSignTime?: boolean;
};

// Storage for previous tx handler
export const PREVIOUS_TX_SIGNED_HANDLER: {
	current: DriftClientTxSignedHandler | undefined;
} = {
	current: undefined,
};
